const businessLegals = [
  "Sub Chapter M of IRS Conventional C Corporation",
  "Sub Chapter S of IRS Small Corporation",
  "501c3 Non Profit Organization",
  "Limited Liability Company",
  "Virtual Corporation (Registered with Permisible State like CO, UT, CT and So on)",
  "Partnership (Registered)",
  "Limited Partnership (Registered)",
  "DBA (Doing Business As) with Parent Company",
  "DBA (Doing Business As) without Parent Company",
  "Sole Proprietorship",

  // Add more business types here
];

export default businessLegals;
